import { Icon } from '@iconify/react';

export function ThreadsPageSkeleton() {
  return (
    <>
      <article className="group my-6 mx-auto animate-pulse rounded-lg px-2 py-1 lg:max-w-lg xl:max-w-xl">
        <h2 className="my-4">Loading threads...</h2>
        <div className="flex flex-row items-center justify-between">
          <div className="flex h-10 flex-row items-center gap-3">
            <div className="grid h-9 w-9 place-items-center overflow-hidden rounded-full bg-yellow-500 text-lg" />
            <div className="flex animate-pulse flex-col gap-1">
              <div className="h-2 text-clip rounded-2xl bg-slate-300 text-xl font-bold drop-shadow-md dark:bg-slate-700" />
              <div className="inline-flex items-center text-sm opacity-90">
                <div className="h-2 w-20 text-clip rounded-lg bg-slate-300 drop-shadow line-clamp-1 dark:bg-slate-700" />
                <div>
                  <Icon icon="ci:dot-03-m" />
                </div>
                <div className="text-clip drop-shadow line-clamp-1 max-[319px]:hidden">
                  <div className="h-2 w-8 rounded-lg bg-slate-300 dark:bg-slate-700" />
                </div>
              </div>
            </div>
          </div>
          <button className="py-2 opacity-30 hover:opacity-90 group-hover:opacity-70">
            <Icon icon="ph:dots-three-outline-vertical-fill" />
          </button>
        </div>

        <div className="mt-3 h-2 overflow-hidden text-clip break-words rounded-xl bg-slate-300 text-lg font-semibold opacity-90 line-clamp-2 hover:text-indigo-800 group-hover:opacity-100 dark:bg-slate-700 dark:hover:text-indigo-200 md:mb-2 lg:text-xl xl:mt-4" />
        <div className="mt-3 mb-1 h-2 overflow-hidden text-clip break-words rounded-xl bg-slate-300 text-lg font-semibold opacity-90 line-clamp-2 hover:text-indigo-800 group-hover:opacity-100 dark:bg-slate-700 dark:hover:text-indigo-200 md:mb-2 lg:text-xl xl:mt-4" />
        <div className="mt-2 flex items-center justify-between gap-2 text-xs opacity-90 group-hover:opacity-100 sm:text-sm 2xl:text-sm">
          <button
            className="inline-flex items-center gap-2 rounded-xl p-2 hover:bg-indigo-300/10 hover:text-indigo-800 dark:hover:bg-indigo-900/5 dark:hover:text-indigo-100"
            title="upvote this"
          >
            <Icon className="h-[1.3em] w-[1.3em]" icon="ic:round-thumb-up" />
            <div className="h-2 w-3 text-clip rounded-lg bg-slate-300 drop-shadow line-clamp-1" />
          </button>
          <button
            className="inline-flex items-center gap-2 rounded-xl p-2 hover:bg-indigo-300/10 hover:text-indigo-800 dark:hover:bg-indigo-900/5 dark:hover:text-indigo-100"
            title="downvote this"
          >
            <Icon className="h-[1.3em] w-[1.3em]" icon="ic:round-thumb-down" />
            <div className="h-2 w-3 text-clip rounded-lg bg-slate-300 drop-shadow line-clamp-1" />
          </button>
          <button className="inline-flex flex-1 items-center justify-center gap-1 rounded-xl p-2 hover:bg-indigo-300/40 hover:text-indigo-800 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-100">
            <Icon className="h-[1.3em] w-[1.3em]" icon="akar-icons:comment" />
            <div className="mx-4 h-2 w-full text-clip rounded-lg bg-slate-300 drop-shadow dark:bg-slate-700" />
          </button>
          <button className="inline-flex items-center gap-1 overflow-hidden rounded-xl p-2 hover:bg-indigo-300/40 hover:text-indigo-800 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-100">
            <Icon
              className="h-[1.3em] w-[1.3em]"
              icon="fluent:share-android-24-regular"
            />
            <div className="h-2 w-6 rounded-xl bg-slate-300 dark:bg-slate-700" />
          </button>
        </div>
      </article>
      <article className="group my-6 mx-auto animate-pulse rounded-lg px-2 py-1 lg:max-w-lg xl:max-w-xl">
        <div className="flex flex-row items-center justify-between">
          <div className="flex h-10 flex-row items-center gap-3">
            <div className="grid h-9 w-9 place-items-center overflow-hidden rounded-full bg-sky-500 text-lg" />
            <div className="flex animate-pulse flex-col gap-1">
              <div className="h-2 text-clip rounded-2xl bg-slate-300 text-xl font-bold drop-shadow-md dark:bg-slate-700" />
              <div className="inline-flex items-center text-sm opacity-90">
                <div className="h-2 w-20 text-clip rounded-lg bg-slate-300 drop-shadow line-clamp-1 dark:bg-slate-700" />
                <div>
                  <Icon icon="ci:dot-03-m" />
                </div>
                <div className="text-clip drop-shadow line-clamp-1 max-[319px]:hidden">
                  <div className="h-2 w-8 rounded-lg bg-slate-300 dark:bg-slate-700" />
                </div>
              </div>
            </div>
          </div>
          <button className="py-2 opacity-30 hover:opacity-90 group-hover:opacity-70">
            <Icon icon="ph:dots-three-outline-vertical-fill" />
          </button>
        </div>

        <div className="mt-3 h-2 overflow-hidden text-clip break-words rounded-xl bg-slate-300 text-lg font-semibold opacity-90 line-clamp-2 hover:text-indigo-800 group-hover:opacity-100 dark:bg-slate-700 dark:hover:text-indigo-200 md:mb-2 lg:text-xl xl:mt-4" />
        <div className="mt-3 mb-1 h-2 overflow-hidden text-clip break-words rounded-xl bg-slate-300 text-lg font-semibold opacity-90 line-clamp-2 hover:text-indigo-800 group-hover:opacity-100 dark:bg-slate-700 dark:hover:text-indigo-200 md:mb-2 lg:text-xl xl:mt-4" />
        <div className="mt-2 flex items-center justify-between gap-2 text-xs opacity-90 group-hover:opacity-100 sm:text-sm 2xl:text-sm">
          <button
            className="inline-flex items-center gap-2 rounded-xl p-2 hover:bg-indigo-300/10 hover:text-indigo-800 dark:hover:bg-indigo-900/5 dark:hover:text-indigo-100"
            title="upvote this"
          >
            <Icon className="h-[1.3em] w-[1.3em]" icon="ic:round-thumb-up" />
            <div className="h-2 w-3 text-clip rounded-lg bg-slate-300 drop-shadow line-clamp-1" />
          </button>
          <button
            className="inline-flex items-center gap-2 rounded-xl p-2 hover:bg-indigo-300/10 hover:text-indigo-800 dark:hover:bg-indigo-900/5 dark:hover:text-indigo-100"
            title="downvote this"
          >
            <Icon className="h-[1.3em] w-[1.3em]" icon="ic:round-thumb-down" />
            <div className="h-2 w-3 text-clip rounded-lg bg-slate-300 drop-shadow line-clamp-1" />
          </button>
          <button className="inline-flex flex-1 items-center justify-center gap-1 rounded-xl p-2 hover:bg-indigo-300/40 hover:text-indigo-800 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-100">
            <Icon className="h-[1.3em] w-[1.3em]" icon="akar-icons:comment" />
            <div className="mx-4 h-2 w-full text-clip rounded-lg bg-slate-300 drop-shadow dark:bg-slate-700" />
          </button>
          <button className="inline-flex items-center gap-1 overflow-hidden rounded-xl p-2 hover:bg-indigo-300/40 hover:text-indigo-800 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-100">
            <Icon
              className="h-[1.3em] w-[1.3em]"
              icon="fluent:share-android-24-regular"
            />
            <div className="h-2 w-6 rounded-xl bg-slate-300 dark:bg-slate-700" />
          </button>
        </div>
      </article>
    </>
  );
}
